export default __webpack_public_path__ + "static/media/aikit.28c3a4f7.svg";